/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon64Regular = forwardRef('MediaUiAEjectIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.967 35.31C6.512 38.426 8.732 43 12.698 43h38.604c3.966 0 6.186-4.574 3.73-7.69L35.732 10.812c-1.902-2.414-5.56-2.414-7.462 0L8.967 35.31ZM12.698 40c-1.461 0-2.279-1.685-1.375-2.833l19.302-24.499a1.75 1.75 0 0 1 2.75 0l19.301 24.499c.905 1.148.087 2.833-1.374 2.833H12.698Z" }),
        React.createElement("path", { d: "M9.5 50a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 1 0 0-3h-45Z" })));
});
